import { render } from "./LoveAdmin.vue?vue&type=template&id=b73c125a"
import script from "./LoveAdmin.vue?vue&type=script&lang=js"
export * from "./LoveAdmin.vue?vue&type=script&lang=js"

import "./LoveAdmin.vue?vue&type=style&index=0&id=b73c125a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__